module.exports = "/shifts/shift-acceptance/shiftAcceptanceBulkButtonComponent-b3a047.html";